import { env } from "configs/EnvironmentConfig";
import { ALL_BU } from "constants/DashboardContanst";
import fetch from "../auth/FetchInterceptor";

const ErrorInvoiceService = {};

// Thông báo hóa đơn sai sót
ErrorInvoiceService.listInvoiceErrors = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort,
  bu_code,
  bu_parent
) {
  return fetch({
    url: `${env.API_MSP}/invoice-errors`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      keywords: keywords ? keywords : undefined,
    },
  });
};

// reviewPdfRegisterInvoice
ErrorInvoiceService.reviewPdfErrorInvoice = function (
  id,
  patch = "review-pdf"
) {
  return fetch({
    url: `${env.API_MSP}/invoice-errors/${patch}/${id}`,
    method: "get",
  });
};
// ErrorInvoiceService
ErrorInvoiceService.downloadFileXML = (resource_id, responseType) => {
  return fetch({
    url: `${env.API_MSP}/invoice-errors/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// Create Error Invoices
ErrorInvoiceService.createErrorInvoices = ({ data }, bu_code) => {
  return fetch({
    url: `${env.API_MSP}/invoice-errors`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// Edit Error Invoices
ErrorInvoiceService.editErrorInvoices = (data, id) => {
  return fetch({
    url: `${env.API_MSP}/invoice-errors/${id}`,
    method: "put",
    data,
  });
};

// transfer
ErrorInvoiceService.transfer = function (data) {
  return fetch({
    url: `${env.API_MSP}/hooks/transfer`,
    method: "post",
    data,
  });
};

// Release Error Invoices
ErrorInvoiceService.releaseErrorInvoices = id => {
  return fetch({
    url: `${env.API_MSP}/invoice-errors/release/${id}`,
    method: "post",
  });
};

// Delete Error Invoices
ErrorInvoiceService.deleteErrorInvoices = id => {
  return fetch({
    url: `${env.API_MSP}/invoice-errors/${id}`,
    method: "delete",
  });
};

// Search Invoice Error Invoices
ErrorInvoiceService.searchInvoiceErrorInvoices = ({ params }, bu_code) => {
  return fetch({
    url: `${env.API_MSP}/invoice-errors/search-invoice`,
    method: "get",
    params: {
      ...params,
      bu_code: params.bu_code
        ? params.bu_code
        : bu_code !== ALL_BU
        ? bu_code
        : undefined,
      expand: params.expand || "",
    },
  });
};
// List Type Invoice Error Invoices
ErrorInvoiceService.listTypeInvoiceErrorInvoices = ({ params }) => {
  return fetch({
    url: `${env.API_MSP}/invoice-errors/get-type-invoice`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || "",
    },
  });
};

// List Notification Properties Error Invoices
ErrorInvoiceService.listNotificationPropertiesErrorInvoices = ({ params }) => {
  return fetch({
    url: `${env.API_MSP}/invoice-errors/get-nature`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || "",
    },
  });
};

export default ErrorInvoiceService;
